// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3io3x","row":"Node_row__31B0R","label":"Node_label__1xf8l","footer":"Node_footer__1xeNZ"};